export enum LecturerRateDisplayType {
  OneHour = 'one_hour',
  AcademicHour = 'academic_hour',
}
